/**
 * 請求先の検索ダイアログ
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'
import * as types from '../../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/billing_address_members`

const getDefaultState = () => {
  return {
  }
}
const biling_address_member = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     *
     * @param commit
     * @param params
     * @property code { string } 請求先コード
     * @property name { string } 名称
     * @property self_tenant { boolean} 自身のテナントのみ
     * @property page { number } ページ番号
     * @return {Promise<unknown>}
     */
    index ({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
  },
  mutations: {},
}
export default biling_address_member

